import * as React from 'react'
import classnames from 'classnames'

type SurfaceProps = React.PropsWithChildren & {
    className?: string
    padding?: SurfacePadding
}
type SurfacePadding = 'medium' | 'large'

export const Surface: React.FC<SurfaceProps> = (props) => {
    const { children, padding = 'medium' } = props
    const className = classnames(
        'bg-white border border-neutral-200 rounded-lg',
        getSurfacePadding(padding),
        props.className
    )

    return <div className={className}>{children}</div>
}

const getSurfacePadding = (padding: SurfacePadding) => {
    const paddingValues: Record<SurfacePadding, string> = {
        medium: 'p-4',
        large: 'p-6',
    }

    return classnames(paddingValues[padding])
}
